import { render, staticRenderFns } from "./charger.vue?vue&type=template&id=a8322e42&scoped=true&"
import script from "./charger.vue?vue&type=script&lang=js&"
export * from "./charger.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8322e42",
  null
  
)

export default component.exports